import { createContext, ReactNode, useContext, useState, useCallback } from 'react';

type FiltersDrawerContextType = {
    isOpen: boolean;
    openFiltersDrawer: () => void;
    closeFiltersDrawer: () => void;
};

const FiltersDrawerContext = createContext<FiltersDrawerContextType | undefined>(undefined);

type FiltersDrawerProviderProps = {
    children: ReactNode;
};

export function FiltersDrawerProvider({
    children,
}: Readonly<FiltersDrawerProviderProps>): JSX.Element {
    const [isOpen, setIsOpen] = useState(false);

    const openFiltersDrawer = useCallback(() => setIsOpen(true), []);
    const closeFiltersDrawer = useCallback(() => setIsOpen(false), []);

    return (
        <FiltersDrawerContext.Provider value={{ isOpen, openFiltersDrawer, closeFiltersDrawer }}>
            {children}
        </FiltersDrawerContext.Provider>
    );
}

export function useFiltersDrawer(): FiltersDrawerContextType {
    const context = useContext(FiltersDrawerContext);
    if (context === undefined) {
        throw new Error('useFiltersDrawer must be used within a FiltersDrawerProvider');
    }
    return context;
}
